import { action, payload } from 'ts-action'
import { IRoster } from 'models/Roster'
import { IError, IPayload } from 'models/Global'

export const RostersFetching = action('RostersFetching', payload<boolean>())

export const GetRosters = action('GetRosters', payload<IPayload<IRoster[]>>())

export const DeleteRoster = action('DeleteRoster', payload<number>())

export const GetRostersErrors = action('GetRostersErrors', payload<IError>())

export const ReorderRosters = action(
  'ReorderRosters',
  payload<{
    oldIndex: number
    newIndex: number
  }>(),
)
